<template>
    <div id="left_slider">
        <div class="ls_controls" v-if="$props.disabled!==true">
            <div class="ls_add_buttons" v-show="!adding">
                <div class="ls_left"><i class="material-icons" @click="open_input">videocam</i></div>
                <div class="ls_right"><i class="material-icons" @click="add_img">image</i></div>
            </div>
            <div class="ls_video_url flexsplit" v-show="adding">
                <v-text-field label="Video URL" v-model="url"></v-text-field>
                <button type="button" class="fluke-btn add_button" @click="add_video">add</button>
            </div>
        </div>
        <slider-list v-model="slides" :disabled="$props.disabled"></slider-list>
        <input
            ref="img_selector"
            class="img_selector"
            type="file"
            v-on:change="uploadFile" />
        <image-picker ref="imagepicker" v-model="image_address" :disabled="$props.disabled"></image-picker>
    </div>
</template>

<script>
import axios from 'axios';

import SliderList from './LeftSliderList';
import ImagePicker from './../ImageGallery/ImageGallery';

export default {
    props: [ 'disabled' ],
    components: {
        SliderList,
        ImagePicker
    },
    data: function() {
        return {
            slides: [],
            url: '',
            adding: false,
            image_address: ''
        }
    },
    watch: {
        slides: function(){
            this.$emit('input', this.slides);
        },
        '$attrs.value': function()
        {
            this.slides = this.$attrs.value;
        },
        image_address: function()
        {
            if( this.image_address != '' )
            {
                this.slides.push({
                    type: 'img',
                    url: this.image_address
                });
                this.image_address = '';
            }
        }

    },
    methods: {
        add: function()
        {
            if( (Math.random() * 10)>=5 ) {
                this.slides.push({
                    type: 'img',
                    url: 'Imagem',
                    html: ''
                });
            } else {
                this.slides.push({
                    type: 'video',
                    url: 'Imagem',
                });
            }
        },
        add_video: function()
        {
            var regex = new RegExp(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
            var codeArr = this.url.match(regex);

            this.slides.push({
                type: 'video',
                url: codeArr[1]
            });

            this.url = '';
            this.adding = false;
        },
        add_img: function()
        {
            // this.$refs.img_selector.click();
            this.$refs.imagepicker.open();
            this.adding = false;
        },
        open_input: function()
        {
            this.adding = true;
        },
        uploadFile: function(){
            this.url = '';

            var formData = new FormData();
            formData.append( 'files', this.$refs.img_selector.files[0] );

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Fluke': this.$cookies.get('token'),
                }
            };

            axios
                .post( this.$myServerAddresses.images, formData, config )
                .then( result => {
                    if( result.data.success )
                    {
                        this.slides.push({
                            type: 'img',
                            url: result.data.file
                        });
                    }
                })
                .catch( err => {
                    console.log( err );
                })
        }
    }
}
</script>

<style lang="scss">
.ls_controls {
    margin-bottom: 15px;
    display: flex;
    height: 46px;

    .ls_add_buttons {
        display: flex;

        & > div {
            display: flex;
            // border: 1px solid #000;
            padding: 3px 8px;
            background: #eee;
        }

        .ls_left {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        .ls_right {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border-left: 1px solid #fff;
        }
        .ls_right,
        .ls_left {
            height: 30px;
        }
    }
    .add_button {
        height: 50px;
    }
    .ls_video_url {
        .v-text-field__details { display: none; }
        .v-input__slot { margin-bottom: 0; }
    }
}
.img_selector {
    display: none;
}
</style>
